import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionThumbsUpColorIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <circle cx="8.5" cy="8.173" r="8" fill="#007AFF" />
    <path
      fill="#fff"
      d="M3.611 12.173H5.39V6.839H3.611v5.334Zm9.778-4.89c0-.488-.4-.888-.889-.888H9.696l.422-2.031.013-.142a.669.669 0 0 0-.195-.471l-.471-.467L6.54 6.213a.869.869 0 0 0-.262.626v4.445c0 .489.4.889.889.889h4a.883.883 0 0 0 .818-.542l1.342-3.134a.878.878 0 0 0 .062-.324v-.89Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M3.167 2.84h10.667v10.667H3.167z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ReactionThumbsUpColorIcon);
